import type React from 'react';

import { FormField, FormHelp, Label, Paragraph } from '@zillow/constellation-10';

import type { Section } from '../../../../models';
import { HEATING_CHARGE } from '../../../../constants';
import CurrencyInput from '../../../Widgets/CurrencyInput';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function HeatingCharge({ section, setSectionValues }: Props) {
  function onMonthlyHeatingChargeChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [HEATING_CHARGE.FIELD_NAME.MONTHLY_CHARGE]: value,
    });
  }

  function onAnnualHeatingChargeChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [HEATING_CHARGE.FIELD_NAME.ANNUAL_CHARGE]: value,
    });
  }

  return (
    <>
      <Paragraph textStyle="body-lg-bold">Heating</Paragraph>
      <FormField
        required
        css={{ marginTop: 'layout.tight', marginBottom: 'layout.tight' }}
        label={
          <Label>
            What is the average monthly cost of utility service of the utility providing the primary source of heat
            based on the energy consumption during the previous 12 months of occupancy?
          </Label>
        }
        control={
          <CurrencyInput
            value={section.getFieldValue(HEATING_CHARGE.FIELD_NAME.MONTHLY_CHARGE)}
            onChange={onMonthlyHeatingChargeChange}
            onBlur={onMonthlyHeatingChargeChange}
            endAdornment="per month"
          />
        }
      />
      <FormField
        required
        label={
          <Label>
            What is the projected annual cost of utility service of the utility providing the primary source of heat
            based on the energy consumption during the previous 12 months of occupancy?
          </Label>
        }
        control={
          <CurrencyInput
            value={section.getFieldValue(HEATING_CHARGE.FIELD_NAME.ANNUAL_CHARGE)}
            onChange={onAnnualHeatingChargeChange}
            onBlur={onAnnualHeatingChargeChange}
          />
        }
        description={<FormHelp>If you don’t know the projected annual cost, multiply your monthly cost by 12</FormHelp>}
      />
    </>
  );
}

HeatingCharge.description = 'Chicago specific screen asking about annual heating charge';

export default HeatingCharge;
